import React, { CSSProperties } from 'react';

import { RoundMedia } from '../../../services/backendService/types';
import { SUPPORTED_IMAGE_MIMETYPES } from '../../../utils/fileDropUtils';
import GameImageRenderer from '../GameImageRenderer';
import { ImgStyled } from '../GameImageRenderer/GameImageRenderer';
import GifRenderer from '../GifRenderer';
import VideoURLRenderer from '../VideoURLRenderer';

const GameMediaRenderer = ({
  media,
  isDiscoverTemplate,
  onImageClicked,
  useThumbnail,
  style,
  isAuthenticated,
  isOwner,
}: {
  media: RoundMedia;
  isDiscoverTemplate: boolean;
  useThumbnail?: boolean;
  onImageClicked?: (url: string) => void;
  style?: React.CSSProperties;
  isAuthenticated: boolean;
  isOwner: boolean;
}) => {
  if (media.fileMimeType === 'giphy/gif') {
    return (
      <GifRenderer
        style={style}
        gifId={media.fileId}
        altText={media.fileAltText ? media.fileAltText : undefined}
        onImageClicked={onImageClicked}
      />
    );
  }

  if (media.fileMimeType === 'iframe/video') {
    return (
      <VideoURLRenderer
        style={style}
        videoId={media.fileId}
        altText={media.fileAltText}
      />
    );
  }
  if (SUPPORTED_IMAGE_MIMETYPES.includes(media.fileMimeType)) {
    return (
      <GameImageRenderer
        style={style}
        brightness={media.brightness}
        fileId={media.fileId}
        fileMimetype={media.fileMimeType}
        fileAltText={media.fileAltText}
        cropConfig={media.cropConfig}
        isDiscoverTemplate={isDiscoverTemplate}
        onImageClicked={onImageClicked}
        isAuthenticated={isAuthenticated}
        isOwner={isOwner} // it should be impossible to not be owner and authenticated
      />
    );
  }

  // TODO
  /**  
   * consider placing or custom mimetype somewhere in a file or variable?
  image/color giphy/gif image/jpeg image/unsplash
  Maybe we should avoid using image for urls
  giphy/gif unsplash/image curipod/color
  */

  if (media.fileMimeType === 'image/unsplash' && media.downloadLocation && media.fileId) {
    return (
      <UnsplashDownloadPhoto
        fileId={useThumbnail ? media.thumbnailSrc || media.fileId : media.fileId}
        fileAltText={media.fileAltText}
        onImageClicked={onImageClicked}
        style={style}
        brightness={media.brightness}
      />
    );
  }
  if (media.fileMimeType === 'image/color' && media.fileId) {
    return (
      <div
        style={{
          backgroundColor: media.fileId,
          height: '100%',
          width: '100%',
          filter: `brightness(${(media.brightness || 0.5) + 0.5})`,
        }}
      />
    );
  }

  return null;
};

const UnsplashDownloadPhoto = ({
  fileId,
  onImageClicked,
  fileAltText,
  style,
  brightness,
}: {
  fileId: string;
  fileAltText?: string | null;
  onImageClicked?: (url: string) => void;
  style?: CSSProperties;
  brightness?: number | null;
}) => {
  return (
    <ImgStyled
      src={fileId}
      alt={fileAltText || ''}
      onClick={() => onImageClicked && fileId && onImageClicked(fileId)}
      $clickable={!!onImageClicked}
      $brightness={brightness}
      style={style}
    />
  );
};
export default GameMediaRenderer;
